// Visit The Stimulus Handbook for more details
// https://stimulusjs.org/handbook/introduction
//
// This example controller works with specially annotated HTML like:
//
// <div data-controller="hello">
//   <h1 data-target="hello.output"></h1>
// </div>

import { Controller } from "stimulus"
import Events from '../classes/Events';
const errorClasses = [
  't-border-red-600'
]

class Form extends Controller {

  async submit(e) {
    e.preventDefault();
    const hasError = await this.triggerValidations();
    if (!hasError) {
      this.element.dispatchEvent(Events.validatedEvent);
    }
  }

  targetNames() {
    return [];
  }

  async triggerValidations() {
    const validationPromises = this.targetNames().map(targetName => (
      this[`${targetName}Targets`].map(target => 
        new Promise((resolve) => {
          EventManager.emit(
            'validation_triggered',
            {
              controller: this.identifier,
              target: target,
              callback: result => {
                resolve(result)
              }
            }
          )
      })))).flat();
    const allValidatedResult = await Promise.all(validationPromises || [])
    return allValidatedResult.some(result => !result)
  }

  handleValidation(e) {
    const { target } = e;
    if (target.dataset['error'] && target.dataset['error'] !== 'null') {
      this.createErrorMessage(target, target.dataset['error'])
      target.classList.add(errorClasses)
    } else {
      this.clearErrorMessage(target)
      target.classList.remove(errorClasses)
    }
  }

  createErrorMessage(anchorElement, message) {
    this.clearErrorMessage(anchorElement);
    const errorMessage = document.createElement('p');
    errorMessage.classList.add('t-text-xs', 't-text-red-700', 'validation-error', 't-mt-1');
    errorMessage.innerHTML = this.parseLinksInText(message);
    anchorElement.parentNode.insertBefore(errorMessage, anchorElement.nextSibling);
  }

  clearErrorMessage(anchorElement) {
    anchorElement.parentNode.querySelectorAll('.validation-error').forEach(node => {
      node.remove();
    })
  }

  parseLinksInText = text => {
    const linkPatterns = [
      {
        name: '[sign in]',
        parsedHtml: '<a class="t-m-0 t-text-indigo-700" href="/login/">sign in</a>'
      }
    ]
    let result = text;
    linkPatterns.forEach(pattern => {
      result = result.replace(pattern.name, pattern.parsedHtml)
    })
    return result;
  }
}

export default Form;
